import { useState } from "react";
import { Layout, Layouts, Responsive, WidthProvider } from "react-grid-layout";
import { Interval } from "../../navigation/tabs/Tabs";
import { Graph, GraphType } from "../../graph/Graph";
import { Area } from "../../navigation/tree/Area";
import classes from "../Statistics.module.css"

interface IProps {
    area: Area
    nodePath: string,
    startDateTimestamp: number,
    endDateTimestamp: number,
    interval: Interval
}

export const StatsGSM = (props: IProps) => {
    const ResponsiveReactGridLayout = WidthProvider(Responsive);
    const [layouts, setLayouts] = useState<Layouts>({})

    return (
        <ResponsiveReactGridLayout
                rowHeight={100}
                cols={{ lg: 12, md: 12, sm: 6, xs: 4, xxs: 2 }}
                layouts={layouts}
                onLayoutChange={(_currentLayout: Layout[], allLayouts: Layouts) => {
                    // Check to prevent infinite refresh
                    if(JSON.stringify(allLayouts) !== JSON.stringify(layouts)){
                        setLayouts(allLayouts)
                    }
                }
            }>

                <div className={classes.ChartContainer} key={"stat1"} data-grid={{ w: 6, h: 3, x: 0, y: 0, static: true }}>
                        <label>Qualité signal GSM</label>
                        <div className={classes.ChartTitleSeparator}/>
                        <div className={classes.ChartGraphContainer}>            
                            <Graph
                                preventUpdateAnimations={false}
                                graphType={GraphType.SIGNAL_QUALITY_EVOLUTION}
                                startDatePeriodTimestamp={props.startDateTimestamp}
                                endDatePeriodTimestamp={props.endDateTimestamp}
                                mediaspotSerial={props.area.mediaspot?.serial}
                                interval={props.interval}
                                nodePath={props.nodePath}/>
                        </div>
                </div>

                {
                    props.area.hasMediaspot === true && props.area.mediaspot ?
                        <div className={classes.ChartContainer} key={"stat2"} data-grid={{ w: 6, h: 3, x: 6, y: 0, static: true }}>
                                <label>Consommation data</label>
                                <div className={classes.ChartTitleSeparator}/>
                                <div className={classes.ChartGraphContainer}>            
                                <Graph
                                        preventUpdateAnimations={false}
                                        graphType={GraphType.DATA_USAGE_EVOLUTION}
                                        startDatePeriodTimestamp={props.startDateTimestamp}
                                        endDatePeriodTimestamp={props.endDateTimestamp}
                                        interval={props.interval}
                                        mediaspotSerial={props.area.mediaspot.serial}
                                        nodePath={props.nodePath}/>
                                </div>
                        </div> : <div key="empty_1"/>
                }

            </ResponsiveReactGridLayout>
        
    )
}